export const sub_modules_order = {
   'users': 1,
   'partners': 2,
   'products': 3,
   'scripts': 4,
   'security': 5
}